export default __webpack_public_path__ + "static/media/coins.63caa088.svg";